export function registerBottomNav(Alpine) {
    Alpine.data('bottomNav', () => ({
        navigating: false,
        activeHref: null,

        init() {
            window.addEventListener('pagehide', () => {
                this.navigating = false;
                this.activeHref = null;
            });
            window.addEventListener('pageshow', (e) => {
                if (e.persisted) {
                    this.navigating = false;
                    this.activeHref = null;
                }
            });
        },

        navigate(href) {
            if (!href || href === '#') return;
            this.activeHref = href;
            this.navigating = true;
            requestAnimationFrame(() => {
                window.location.href = href;
            });
        },

        isActive(href) {
            return this.activeHref === href;
        }
    }));
}
